export const intlEsEs = {
    测试: 'Prueba',
    登录: 'Iniciar sesión',
    注册: 'Inscribirse',
    变量的例子: 'Ejemplo de variable {value}',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">Ejemplo de variable <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'educación Física',
    存款: 'DEPOSITAR',
    提款: 'RETITAR',
    请登录: 'Por favor inicie sesión',
    余额刷新成功: 'Saldo actualizado con éxito',
    我的金额: 'Mi dinero',
    我的邀请码: 'Mi código de invitación',
    复制成功: 'Copiado con éxito',
    下一次抽奖: 'Próximo sorteo',
    您没有抽奖的机会: 'No tienes oportunidad de sorteo',
    规则: 'Reglas',
    我的: 'PERFIL',
    我的信息: 'Mi información',
    资金详情: 'Detalles del dinero',
    在线客服: 'Servicio al cliente en línea',
    客服暂未配置: 'Servicio al cliente no configurado',
    促销码: 'Código promocional',
    请输入促销码: 'Por favor ingrese el código promocional',
    验证码: 'Código de verificación',
    请输入验证码: 'Por favor ingrese el código de verificación',
    提交: 'Enviar',
    退出登录: 'Cerrar sesión',
    提示: 'Consejo',
    '确定要退出登录吗？': '¿Estás seguro de que quieres cerrar sesión?',
    取消: 'Cancelar',
    确定: 'Confirmar',
    '升级到 {value} 还需要 {value}': 'Actualizar a {value1} aún necesita {value2}',
    头像: 'Avatar',
    用户名: 'Nombre de usuario',
    登录密码: 'Contraseña de inicio de sesión',
    提现密码: 'Contraseña de retiro',
    修改提现密码: 'Cambiar contraseña de retiro',
    修改密码: 'Cambiar contraseña',
    设置提现密码: 'Establecer contraseña de retiro',
    请输入提现密码: 'Por favor ingrese la contraseña de retiro',
    请再次输入提现密码: 'Por favor ingrese la contraseña de retiro nuevamente',
    提现密码不能为空: 'La contraseña de retiro no puede estar vacía',
    确认提现密码不能为空: 'La confirmación de la contraseña de retiro no puede estar vacía',
    提现密码格式不正确: 'Formato de contraseña de retiro incorrecto',
    确认提现密码格式不正确: 'Formato de confirmación de contraseña de retiro incorrecto',
    提现密码和确认提现密码不一致: 'La contraseña de retiro y la confirmación de la contraseña de retiro no coinciden',
    设置提现密码成功: 'Establecer contraseña de retiro con éxito',
    请输入旧密码: 'Por favor ingrese la contraseña anterior',
    请输入新密码: 'Por favor ingrese la nueva contraseña',
    请再次输入新密码: 'Por favor ingrese la nueva contraseña nuevamente',
    旧密码不能为空: 'La contraseña anterior no puede estar vacía',
    新密码不能为空: 'La nueva contraseña no puede estar vacía',
    确认密码不能为空: 'La confirmación de la contraseña no puede estar vacía',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'Formato de contraseña anterior incorrecto, ingrese 6-18 caracteres alfanuméricos',
    '新密码格式不正确, 请输入6-18位字母或数字': 'Formato de nueva contraseña incorrecto, ingrese 6-18 caracteres alfanuméricos',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'Formato de confirmación de contraseña incorrecto, ingrese 6-18 caracteres alfanuméricos',
    新密码和确认密码不一致: 'La nueva contraseña y la confirmación de la contraseña no coinciden',
    '修改密码成功, 请重新登录': 'Contraseña cambiada con éxito, inicie sesión nuevamente',
    修改提现密码成功: 'Contraseña de retiro cambiada con éxito',
    选择头像: 'Seleccionar avatar',
    今天: 'Hoy',
    昨天: 'Ayer',
    一个月内: 'Un mes',
    余额: 'Saldo',
    编号: 'Número de identificación',
    备注: 'Nota',
    提现金额: 'Cantidad retirada',
    充值: 'Recargar',
    账变: 'Cambio de cuenta',
    所有类型: 'Todos los tipos',
    每天: 'Diario',
    每周: 'Semanal',
    每月: 'Mensual',
    活动名称: 'Nombre del evento',
    优惠金额: 'Cantidad de descuento',
    申请时间: 'Tiempo de aplicación',
    '发放/审核时间': 'Tiempo de emisión/auditoría',
    状态: 'Estado',
    活动奖项: 'Premios del evento',
    排名: 'Clasificación',
    每日列表: 'Lista diaria',
    每周列表: 'Lista semanal',
    每月列表: 'Lista mensual',
    没有排名: 'Sin clasificación',
    我的投注: 'Mis apuestas',
    我的奖励: 'Mis recompensas',
    剩余排名: 'Clasificación restante',
    空缺: 'Vacante',
    奖励: 'Recompensa',
    总投注: 'Apuesta total',
    投注: 'Apuesta',
    '占所有玩家总投注额的 {value} %': 'Tomar {value} % de la apuesta total de todos los jugadores',
    暂无数据: 'Sin datos',
    首页: 'MENU PRINCIPAL',
    优惠活动: 'ACTIVIDADES',
    推广: 'PROMOCIONES',
    请选择: 'Por favor seleccione',
    年: 'Año',
    月: 'Mes',
    日: 'Día',
    上午: 'Mañana',
    下午: 'Tarde',
    天: 'Día',
    周: 'Semana',
    投注返利详情:
        '<span style="font-size: 10px;color: #d7cab3;">El monto total de la apuesta de tu equipo es {value1}, y puedes obtener hasta <span style="font-size: 14px;color: #fff;font-weight: 600;">{value2}</span> por mes.</span>',
    优惠活动详情: 'Detalles de la promoción',
    活动申请: 'Solicitud de actividad',
    加载中: 'Cargando',
    申请: 'SOLICITAR',
    申请成功: 'Solicitud exitosa',
    申请失败: 'Solicitud fallida',
    所有记录: 'Todos los registros',
    申请中: 'Solicitud',
    发放成功: 'Emisión exitosa',
    审核失败: 'Revisión fallida',
    活动申请记录: 'Registros de la solicitud de actividad',
    原因: 'Razón',
    邮件: 'Correo',
    邮件最多可保存30天: 'LOS CORREOS SE GUARDARA HASTA 30 DIAS',
    删除已读: 'ELIMINAR LEIDOS',
    全部接收: 'RECIBIR TODOS',
    邮件详情: 'Detalles del correo',
    删除: 'Eliminar',
    确认密码: 'Confirmar contraseña',
    真实姓名: 'Nombre real',
    姓: 'Apellido',
    名: 'Nombre',
    邮箱: 'Correo electrónico ',
    邮箱验证码: 'Código de verificación de correo electrónico',
    发送: 'Enviar',
    手机号: 'Número de teléfono móvil',
    手机验证码: 'Código de verificación móvil',
    出生日期: 'Fecha de nacimiento',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: 'tipo de identificación',
    证件号: 'número de identificación',
    推广码: 'Código de promoción',
    优惠码: 'código de canje',
    登录成功: 'Inicio de sesión exitoso',
    登录失败: 'Inicio de sesión fallido',
    登录账号: 'Iniciar sesión en cuenta',
    请输入正确的邮箱: 'Ingrese una dirección de correo electrónico válida',
    请选择手机区号: 'Seleccione un código de área móvil',
    手机号校验: 'Ingrese un Número de móvil de 6 a 12 dígitos',
    请输入10位手机号: 'Ingrese un Número de móvil de 10 dígitos',
    验证码发送成功: 'El código de verificación se envió correctamente',
    用户名验证: 'El nombre de usuario debe comenzar con (6-15) letras y una combinación de letras minúsculas y números',
    用户名不能以test为起始: 'El nombre de usuario no puede comenzar con prueba',
    密码必须为6位数字: 'La contraseña debe tener 6 dígitos',
    确认密码必须为6位数字: 'Confirmar la contraseña debe tener 6 dígitos',
    两次输入的密码不一致: 'Ingrese dos veces La contraseña no coincide.',
    登录密码验证: 'La contraseña debe ser una combinación de (6 a 18 caracteres) de letras, números o caracteres especiales',
    确认登录密码验证: 'Confirme que la contraseña debe ser una combinación de (6 a 18 caracteres) de letras, números o caracteres especiales',
    请输入正确的姓名: 'Ingrese su nombre correcto',
    请输入出生日期: 'Ingrese su fecha de nacimiento',
    请输入您的twitter账号: 'Ingrese su cuenta de {value}',
    请输入您的facebook账号: 'Ingrese su cuenta de Facebook',
    推广码校验: 'Confirme que ha ingresado el código promocional correcto (de 1 a 8 dígitos)',
    推广码校验2: 'Ingresa el código promocional',
    请点击开始验证: 'Haz clic en Iniciar verificación',
    请输入邮箱验证码: 'Ingresa el código de verificación por correo electrónico',
    请输入手机验证码: 'Ingresa el código de verificación móvil',
    请输入姓: 'Ingresa tu apellido',
    请输入名: 'Ingresa tu nombre',
    请输入证件号: 'Ingresa tu número de identificación',
    请输入有效的CURP: 'Ingresa una CURP válida',
    '请输入11~14位数字': 'Ingresa del 11 al 14 dígitos',
    请选择证件类型: 'Seleccione el tipo de identificación',
    请接受服务条款: 'Acepte los términos de servicio',
    邀请奖励: 'RECOMPENSAS DE INVITACIONES',
    问题1: 'P1: ¿Qué significa división de comisión?',
    回答1: 'A1: Después de invitar a amigos a unirse a la aplicación y vincular su código de invitación, recibirá una comisión adicional basada en el consumo de estos amigos en una proporción determinada. ',
    问题2: 'P2: ¿Qué significa club?',
    回答2: 'A2: Su club está formado por todos los miembros de su equipo de agentes.',
    问题3: 'P3: ¿Cómo puedo actualizar a una calificación de estrellas del club más alta?',
    回答3: 'A3: Puede actualizar invitando a más amigos o consumiendo colectivamente con los miembros del equipo. Para obtener información más detallada, consulte la tabla de requisitos de actualización.',
    问题4: 'P4: ¿Cómo recibo recompensas?',
    回答4: 'A4: Una vez que sus amigos o las invitaciones de sus amigos realicen compras, recibirá inmediatamente todas las recompensas, que se depositarán en su cuenta de comisiones y se puede retirar a su billetera al día siguiente.',
    问题5: 'P5: ¿Existe algún requisito de apuesta para retirar recompensas?',
    回答5: 'A5: Existe un requisito de apuesta única.',
    问题6: 'P6: ¿Cuándo puedo usar mis recompensas?',
    回答6: 'A6: Puede retirar sus recompensas a su billetera para gastar el día siguiente. A veces puede haber ligeros retrasos. Gracias por su comprensión.',
    佣金比例详情:
        '※Puede recibir un cierto porcentaje de comisión de todas las apuestas y montos de recarga realizados por A, B y C. Consulte el siguiente diagrama para conocer las tasas de comisión específicas.',
    返利比例详情: '※Los diferentes juegos tienen diferentes reembolsos proporciones. También puede aumentar el índice de reembolso mejorando la calificación de estrellas de su club.',
    立即邀请: '¡Invítelo ahora!',
    佣金率: 'Tasa de comisión',
    流水返利: 'Reembolso por facturación',
    俱乐部之星: 'Estrellas del club',
    佣金等级: 'Comisión nivel {value}',
    首存返利: 'Reembolso por primer depósito',
    什么是俱乐部: '¿Qué es un club?',
    俱乐部的星级越高介绍: 'Usted y todos sus agentes forman su club. Cuanto mayor sea la calificación de estrellas del club, mayor será el índice de reembolso.',
    你的俱乐部: 'Su club',
    如何提高俱乐部的星级: '¿Cómo aumentar la calificación de estrellas del club?',
    代理要求: 'Requisitos del agente',
    投注要求: 'Requisitos de apuestas',
    无星: 'Ninguna estrella',
    一星: 'Una estrella',
    二星: 'Dos estrellas',
    三星: 'Tres estrellas',
    全部: 'Todos',
    我的奖金: 'Mi bono',
    下一级: 'Siguiente nivel',
    累计存款: 'Acumular depósito {value}',
    每日提款限额: 'Límite de retiro diario',
    每日提现次数: 'Cantidad de retiros diarios',
    每月累计存款升级VIP等级: 'Depósito acumulativo mensual Una mejora de nivel VIP',
    等级: 'Nivel',
    月度奖金: 'Bono mensual',
    等级升级奖励: 'Actualización de nivel Bono',
    现金奖励发放时间: 'Bono en efectivo: según su Nivel VIP al final de este mes, esta recompensa se le enviará a las 10 a. m. el primero del próximo mes.',
    晋级彩金: 'Bono de actualización',
    每月奖金: 'Bono mensual',
    投注返水: 'Reembolso de apuesta',
    网络问题: 'Problema de red',
    '检测到您目前没有网络连接，请开启网络后再试。': 'Se detectó que actualmente no tiene conexión de red, abra la red e inténtelo de nuevo.',
    设置: 'Configuraciones',
    总奖励: 'Recompensas totales',
    邀请总数: 'Invitaciones totales',
    邀请有效用户数量: 'Has invitado a un total de {value1} amigos, de los cuales {value2} son usuarios válidos.',
    邀请新客户获得: 'Invita a un nuevo cliente GANAS',
    邀请好友可获得: 'Amigos invitados get',
    邀请好友获取金钱: 'Invita a amigos a obtener dinero',
    每日邀请次数: 'Tiempos de invitación diarios: {value}',
    邀请300位好友可获得: 'Invita a {value} amigos GANAS',
    如何参与: 'CÓMO PARTICIPAR',
    步骤1: 'Paso 1: Regístrese',
    步骤2: 'Paso 2: Haga clic en cualquier página de invitación para invitar a amigos',
    步骤3: 'Paso 3: Los amigos se registran e ingresan el código de invitación',
    步骤4: 'Paso 4: Los amigos depositan {value}',
    步骤5: 'Paso 5: Recibe recompensas',
    什么是有效邀请用户: '¿QUÉ ES UN USUARIO INVITADO VÁLIDO?',
    有效邀请用户描述: 'Un usuario invitado válido es alguien que tiene depositó una cantidad acumulada mayor que {value}',
    奖励兑换: 'REWARD REDEMPTION',
    奖励兑换步骤1: 'Por cada invitación exitosa, el que invita recibe {value1}.',
    奖励兑换步骤2: 'El agente directo (superior del invitador) recibe un bono de {value}.',
    奖励兑换步骤3: 'El agente superior del agente directo recibe un bono de {value}.',
    奖励兑换步骤4: 'El usuario invitado también recibe un bono de {value}.',
    奖励兑换步骤5: 'Las recompensas se pueden utilizar para jugar.',
    奖励兑换步骤6: 'Las recompensas son distribuidas automáticamente por el sistema.',
    活动解释权: '{value} conserva el derecho final de interpretación de esta actividad.',
    '安装权限未被授予，无法打开APK文件': 'No se otorgaron permisos de instalación, no se puede abrir el archivo APK',
    '权限已授予，正在尝试打开APK...': 'Los permisos se han otorgado, intentando abrir APK...',
    立即更新: 'Actualizar ahora',
    稍后更新: 'Actualizar más tarde',
    版本号不符合规范: 'Número de versión no cumple con las normas',
    邀请人数: 'Recuento de invitaciones',
    奖励详情: 'Detalles de la recompensa',
    '网络错误, 请稍后重试!': 'Error de red, ¡inténtalo de nuevo más tarde!',
    存款金额: 'Monto del depósito',
    奖励金额: 'Monto de la recompensa',
    立即存款: 'Deposita ahora',
    今天不再显示: 'No volver a mostrar hoy',
    倒计时: 'cuenta regresiva',
    应用未安装: 'Aplicación no instalada',
    邀请码: 'Código de invitación',
    请输入用户名: 'Por favor ingrese su nombre de usuario',
    密码: 'Contraseña',
    请输入密码: 'Por favor ingrese su contraseña',
    '密码必须为(6~18位)字母或数字组合': 'La contraseña debe ser una combinación de (6 a 18 caracteres) de letras o números',
    忘记密码: '¿Olvidaste tu contraseña?',
    注册账号: 'Registrarse',
    重置密码: 'Restablecer la contraseña',
    '确定进入游戏吗?': '¿Estás seguro de que quieres jugar?',
    进入游戏失败: 'Error al ingresar al juego',
    '确定要支付吗?': '¿Confirmar el pago?',
    充值请求已取消: 'Solicitud de recarga cancelada',
    已提交充值请求: 'Solicitud de recarga enviada',
    存款方式: 'Método de depósito',
    存款账户: 'Cuenta de depósito',
    收款户名: 'Nombre del beneficiario: ',
    银行账户: 'Cuenta bancaria: ',
    开户地址: 'Dirección de la sucursal: ',
    开户银行: 'Banco de apertura: ',
    单笔范围: 'Rango por transacción: ',
    存款优惠: 'Promoción de depósito',
    最高奖金: 'Bono máximo: ',
    剩余数量: 'Cantidad restante: ',
    不选择: 'No elegir',
    请选择优惠: 'Por favor, seleccione la promoción',
    充值优惠详情: 'Detalles de la promoción de recarga',
    详情: 'Detalles',
    最小额: 'Mín',
    最大额: 'Máx',
    存款提示: 'Consejo de depósito',
    存款提示1: 'Cada depósito se acreditará en 1-5 minutos',
    存款提示2: 'Puede contactar con el servicio de atención al cliente en cualquier momento para resolver problemas de depósito',
    充值金额不能小于最小金额: 'El monto de la recarga no puede ser inferior al monto mínimo',
    立即支付: 'Pagar ahora',
    下一步: 'Siguiente',
    USDT数量: 'Cantidad de USDT',
    充值金额: 'Monto de recarga',
    复制: 'Copiar',
    TXID后五位: 'Últimos cinco dígitos de TXID',
    汇款信息: 'Información de la transferencia',
    '(必填)请输入汇款人姓名或者卡号后四位': '(Obligatorio) Por favor, ingrese el nombre del remitente o los últimos cuatro dígitos de la tarjeta',
    上一步: 'Paso anterior',
    备注信息不允许为空: 'La información de la nota no puede estar vacía',
    收款银行: 'Banco receptor ',
    银行地址: 'Dirección del banco ',
    PIX类型: 'Tipo de PIX ',
    账号名称: 'Nombre de la cuenta',
    收款账户: 'Cuenta de cobro ',
    PIX账号: 'Cuenta PIX',
    选择钱包类型: 'Seleccionar tipo de cartera',
    '获取钱包列表失败, 请联系客服': 'Error al obtener la lista de carteras, por favor contacte al servicio de atención al cliente',
    请选择钱包类型: 'Por favor, seleccione el tipo de cartera',
    收款地址: 'Dirección de cobro ',
    当前汇率: 'Tasa de cambio actual',
    转换金额: 'Monto de conversión ',
    单日提现金额上限: 'Límite de retiro diario: ',
    单日提现次数上限: 'Límite de retiros diarios: ',
    单笔最低提现额度: 'Monto mínimo de retiro por transacción: ',
    单笔最高提现额度: 'Monto máximo de retiro por transacción: ',
    提现时间段: 'Período de retiro: ',
    普通余额: 'Saldo normal: ',
    代理余额: 'Saldo de agente: ',
    普通余额可兑换USDT数量: 'Cantidad de USDT que se puede canjear con saldo normal: ',
    代理余额可兑换USDT数量: 'Cantidad de USDT que se puede canjear con saldo de agente: ',
    '你还没绑定三方钱包哦!': '¡Aún no has vinculado una cartera de terceros!',
    选择钱包: 'Seleccionar cartera',
    请输入提现金额: 'Por favor, ingrese el monto del retiro',
    请输入有效金额: 'Por favor, ingrese un monto válido',
    请输入正整数金额: 'Por favor, ingrese un monto entero positivo',
    普通余额不足: 'Saldo normal insuficiente',
    代理余额不足: 'Saldo de agente insuficiente',
    请选择三方钱包: 'Por favor, seleccione una cartera de terceros',
    '你还没虚拟货币地址哦!': '¡Aún no tienes una dirección de criptomonedas!',
    请输入要兑换的USDT数量: 'Por favor, ingrese la cantidad de USDT a canjear',
    请输入有效枚数: 'Por favor, ingrese una cantidad válida',
    请输入正整数枚数: 'Por favor, ingrese una cantidad entera positiva',
    提款数量不能大于可提款USDT数量: 'La cantidad de retiro no puede ser mayor que la cantidad de USDT disponible para retirar',
    请输入提款金额: 'Por favor, ingrese el monto del retiro',
    请选择钱包: 'Por favor, seleccione una cartera',
    '你还没绑定银行卡哦!': '¡Aún no has vinculado una tarjeta bancaria!',
    选择银行卡: 'Seleccionar tarjeta bancaria',
    请选择银行卡: 'Por favor, seleccione una tarjeta bancaria',
    '你还没绑定PIX哦!': '¡Aún no has vinculado PIX!',
    选择PIX: 'Seleccionar PIX',
    请选择PIX类型: 'Por favor, seleccione el tipo de PIX',
    '你还没绑定支付宝哦!': '¡Aún no has vinculado Alipay!',
    选择支付宝: 'Seleccionar Alipay',
    请选择支付宝: 'Por favor, seleccione Alipay',
    去绑定: 'Vincular ahora',
    已选: 'Seleccionado',
    兑换全部: 'Canjear todo',
    当前提款不在时间段内: 'El retiro actual no está dentro del período de tiempo permitido',
    钱包中心: 'Centro de carteras',
    绑卡提示:
        'Estimado usuario, para la seguridad de su información, por defecto solo puede vincular {value} tarjetas. Si necesita excluir o modificar, por favor contacte al servicio de atención al cliente',
    钱包地址: 'Dirección de la cartera',
    请输入钱包地址: 'Por favor, ingrese la dirección de la cartera',
    请输入字母或数字: 'Por favor, ingrese letras o números',
    钱包姓名: 'Nombre de la cartera',
    请输入钱包姓名: 'Por favor, ingrese el nombre de la cartera',
    持卡人姓名: 'Nombre del titular de la tarjeta',
    钱包名称: 'Nombre de la cartera',
    钱包账号: 'Cuenta de la cartera',
    开户行地址: 'Dirección del banco de apertura',
    钱包类型: 'Tipo de cartera',
    "TRC20需以字母'T'开头的34位字符": "TRC20 debe comenzar con la letra 'T' y tener 34 caracteres",
    银行卡类型: 'Tipo de tarjeta bancaria',
    请选择银行卡类型: 'Por favor, seleccione el tipo de tarjeta bancaria',
    请输入开户行地址: 'Por favor, ingrese la dirección del banco de apertura',
    已有银行卡号: 'Número de tarjeta bancaria existente',
    请输入已有银行卡号: 'Por favor, ingrese el número de tarjeta bancaria existente',
    银行卡账号: 'Cuenta de tarjeta bancaria',
    请输入银行卡账号: 'Por favor, ingrese la cuenta de la tarjeta bancaria',
    请输入持卡人姓名: 'Por favor, ingrese el nombre del titular de la tarjeta',
    银行名称: 'Nombre del banco',
    银行账号: 'Cuenta bancaria',
    支付宝姓名: 'Nombre de Alipay',
    请输入支付宝姓名: 'Por favor, ingrese el nombre de Alipay',
    支付宝账号: 'Cuenta de Alipay',
    请输入支付宝账号: 'Por favor, ingrese la cuenta de Alipay',
    添加新账户: 'Agregar nueva cuenta',
    资料信息提交成功: 'Información enviada con éxito',
    联系地址: 'Dirección de contacto',
    请输入联系地址: 'Por favor, ingrese la dirección de contacto',
    完善信息: 'Completar la información',
    请先完善个人信息: 'Por favor, comience a completar la información personal',
    请先选择优惠: 'Por favor, seleccione la oferta',
    请输入PIX账号: 'Por favor, ingrese el PIX',
    活动金额: 'Monto de la actividad',
    更换成功: 'Reemplazo exitoso',
    注册成功: 'registración exitosa',
    注册失败: 'registro fallido',
    请选择线路: 'Por favor, seleccione la línea',
    '线路{value}': 'Línea {value}',
    存款前请先绑定银行卡: 'Antes de depositar, por favor vincule su tarjeta bancaria',
    额度回收: 'Recuperación de la cuota',
    一键刷新: 'actualización con un clic',
    一键回收: 'reciclaje con un clic',
    主平台金额: 'monto de la plataforma principal',
    我的团队俱乐部: 'Mi club de equipos',
    俱乐部星级: 'Nivel de estrellas del club',
    俱乐部星级提示: 'El nivel de estrellas del club se basa en el consumo total de su equipo de agentes. Cuanto mayor sea el consumo, mayor será el nivel de estrellas.',
    俱乐部成员: 'Miembros del club',
    俱乐部投注: 'Apuestas del club',
    我的返佣: 'Mi comisión:',
    投注返佣高达: 'Reembolso de apuestas de hasta',
    首次存款返佣: 'Reembolso por primer depósito',
    可领取: 'Puede recibir',
    领取: 'Recibir',
    领取成功: 'Recibido con éxito',
    领取失败: 'Error al recibir',
    今日奖励: 'Recompensa de hoy',
    邀请朋友: 'Invitar amigos',
    通过WhatsApp邀请: 'Invitar a través de WhatsApp',
    保存图片: 'Guardar imagen',
    分享: 'Compartir',
    从属数据: 'Datos subordinados',
    总人数: 'Número total de personas',
    本月: 'Este mes',
    层级: 'Nivel',
    加入时间: 'Fecha de unión',
    佣金: 'Comisión',
    提款历史记录: 'Historial de retiros',
    邀请: 'Invitar',
    邀请任务: 'Tarea de invitación',
    时间: 'Tiempo',
    佣金金额: 'Monto de la comisión',
    成功: 'Éxito',
    下级: 'Subordinado',
    受邀人数: 'Número de invitados',
    佣金总额: 'Monto total de comisiones',
    提现公告: '{value1} retira con éxito {value2}',
    个人资料: 'Perfil',
    用户信息: 'Información del usuario',
    昵称: 'Nombre de usuario',
    今天1: 'Hoy',
    昨天1: 'Ayer',
    奖励详情1: 'Detalles de la recompensa',
    投注1: 'Apuesta',
    存款1: 'Depósito',
    状态1: 'Estado',
    邀请奖励高达: 'Recompensa de invitación de hasta',
    平台名称: 'Nombre de la plataforma',
    金额: 'Monto',
    刷新: 'Actualizar',
    回收: 'Reciclar',
    休眠提示: 'Clics demasiado frecuentes, por favor intente nuevamente después de {value} segundos',
    刷新成功: 'Actualización exitosa',
    刷新失败: 'Actualización fallida',
    回收成功: 'Reciclaje exitoso',
    回收失败: 'Reciclaje fallido',
    存款提示3: '1. Cada depósito se acreditará en un plazo de 1 a 5 minutos.',
    存款提示4: '2. Puede ponerse en contacto con el servicio de atención al cliente en cualquier momento para resolver problemas de depósito.',
    提款提示: 'Consejos para retirar',
    提款提示1: 'En circunstancias normales, el monto de retiro llegará a su cuenta en aproximadamente 2 horas, y el tiempo máximo de retiro no superará las 24 horas',
    钱包: 'Billetera',
    我的余额: 'Mi saldo',
    绑定手机号: 'Vincular número de teléfono',
    绑定成功: 'Vinculación exitosa',
    未绑定: 'Desvinculación',
    验证码发送失败: 'Error al enviar el código de verificación',
    投注记录: 'Historial de apuestas',
    投注金额: 'Monto de la apuesta',
    投注时间: 'Tiempo de la apuesta',
    订单号: 'Número de pedido',
    平台: 'Plataforma',
    游戏名: 'Nombre del juego',
    玩法: 'Jugabilidad',
    投注模式: 'Modo de apuesta',
    有效投注: 'Apuesta válida',
    盈亏金额: 'Ganancia y pérdida',
    '1、功能优化、性能优化': '1. Optimización de funciones y rendimiento',
    '2、修复一些已知问题': '2. Solución de algunos problemas conocidos',
    发现新版本: 'Nueva versión encontrada',
    奖励2: 'Recompensa',
    下一次免费旋转: 'Próximo giro gratis',
    请输入正确的IFSC码: 'Ingrese el código IFSC correcto',
    记录: 'Registrar',
    提款剩余时间: 'Tiempo restante para retirar',
    收集提现: 'Para retirar cuando acumules {value}',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">Solo falta <span style="font-size: 13px;color: #e9b742;">{value}</span></span>',
    邀请好友获得免费旋转: 'Invitar a amigos para obtener un giro gratis',
    选择您的奖励: 'Elige tu recompensa',
    每日免费提款: 'Retiros diarios gratuitos',
    所有时间: 'Todo el tiempo',
    本周: 'Esta semana',
    上周: 'La semana pasada',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'El formato del número de teléfono es incorrecto.',
    请输入真实姓名: 'Por favor, introduzca su nombre real.',
    不限制: 'sin limite',
    请输入订单号: 'Por favor ingrese el número de pedido',
    立即游戏: 'Juega ahora',
    '存款 {value} 即可获得 {value} 次旋转。': 'Deposita {value1} para obtener {value2} giros.',
    '1次': '{value} vez',
    历史: 'Historial',
    活动规则: 'Reglas de la actividad',
    游戏维护中: 'El juego está en mantenimiento',
    游戏维护时间: 'El juego está en mantenimiento.Tiempo de mantenimiento: {value}',
    快捷登录: 'Inicio de sesión rápido',
    绑定Google账号: 'Vincular cuenta de Google',
    绑定失败: 'Vinculación fallida',
    支持: 'Soporte',
    更多: 'Más',
    提现次数: '{value} veces',
    '请安装Google Play服务': 'Instale Google Play Services',
    '暂无相册权限，请前往设置开启权限': 'Sin permiso de álbum, por favor vaya a la configuración para abrir el permiso',
    '暂无相机权限，请前往设置开启权限': 'Sin permiso de cámara, por favor vaya a la configuración para abrir el permiso',
    '暂无麦克风权限，请前往设置开启权限': 'Sin permiso de micrófono, por favor vaya a la configuración para abrir el permiso',
    '暂无手机存储权限，请前往设置开启权限': 'Sin permiso de almacenamiento, por favor vaya a la configuración para abrir el permiso',
    请输入IFSC码: 'Por favor ingrese el código IFSC',
    搜索: 'buscar',
    恭喜你: '¡Felicidades!',
    用户名或手机号码: 'Nombre de usuario o número de móvil',
    请输入用户名或手机号码: 'Introduzca su nombre de usuario o número de móvil',
    玩法说明: 'Reglas del juego',
    截止时间: 'Hora límite',
    随机投注: 'Apuesta aleatoria',
    游戏记录: 'Historial del juego',
    图表趋势: 'Tendencia del gráfico',
    我的投注记录: 'Mi historial de apuestas',
    期号: 'Número de serie',
    '大/小': 'Grande/Pequeño',
    数字: 'Número',
    颜色: 'Color',
    大: 'Grande',
    小: 'Pequeño',
    '投注助手（过去100期）': 'Asistente de apuestas (últimas 100 rondas)',
    开奖号码: 'Número ganador',
    数量: 'Cantidad',
    我同意: 'Estoy de acuerdo',
    预售规则详情:
        '"Con el fin de proteger los derechos e intereses legítimos de los usuarios que participan en la preventa y mantener el orden de funcionamiento normal, las reglas se implementan de conformidad con los acuerdos y reglamentos pertinentes. 1.1 Definición de preventa: se refiere al modelo de venta en el que los comerciantes brindan soluciones de productos o servicios, recopilan los pedidos de los consumidores a través de herramientas de preventa de productos y brindan a los consumidores bienes o servicios de acuerdo con acuerdos previos. 1.2 El modelo de preventa-venta es un modelo de ""depósito"". ""Depósito"" se refiere a la cantidad fija en el precio de preventa de los productos entregados por adelantado. ""Depósito"" puede participar en minijuegos y tener la oportunidad de ganar más depósitos. Los depósitos se pueden cambiar directamente por mercancías. 1.3 Productos de preventa: se refiere a los productos lanzados por los comerciantes que utilizan la herramienta de productos de preventa. Solo marque la palabra preventa en el título del producto o en la página de detalles del producto, y los productos que no utilizan las herramientas de preventa del producto no se clasifican como productos de preventa. 1.4 Sistema de preventa: se refiere a la herramienta del producto del sistema proporcionada para apoyar a los comerciantes en las ventas del modelo de preventa - venta. 1.5 Precio de productos en preventa: se refiere al precio de venta de los productos en preventa. El precio de los productos de preventa consta de dos partes: depósito y pago final."',
    预售规则: 'Reglas de preventa',
    总金额: 'Monto total',
    投注金额必须大于0: 'La cantidad de apuesta debe ser mayor que 0',
    请同意预售规则: 'Por favor acepte las reglas de preventa',
    投注小于最小限额: 'La apuesta es menor que el límite mínimo',
    投注大于最大限额: 'La apuesta es mayor que el límite máximo',
    当前期已封盘: 'La ronda actual está cerrada',
    请选择投注内容: 'Por favor seleccione el contenido de la apuesta',
    投注失败: 'Apuesta fallida',
    投注成功: 'Apuesta exitosa',
    红色: 'Rojo',
    绿色: 'Verde',
    紫色: 'Púrpura',
    购买金额: 'Monto de compra',
    购买数量: 'Cantidad de compra',
    税后金额: 'Monto después de impuestos',
    税收: 'Impuestos',
    结果: 'Resultado',
    选择: 'Seleccionar',
    '输/赢': 'Perder/Ganar',
    创建时间: 'Hora de creación',
    'WIN GO彩票': 'WIN GO Lotería',
    'WIN GO规则详情':
        'Si gasta 100 para operar, después de deducir 2 tarifas de servicio, el valor de su contrato es 98:<br/><br/>1. Seleccione verde: si el resultado muestra 1,3,7,9, obtendrá (98*2) 196; si el resultado muestra 5, obtendrá (98*1,5) 147<br/><br/>2. Seleccione rojo: si el resultado muestra 2,4,6,8, obtendrá (98*2) 196; si el resultado muestra 0, obtendrá (98*1,5) 147<br/><br/>3. Selecciona violeta: si el resultado muestra 0 o 5, recibirás (98*4.5) 441<br/><br/>4. Seleccione el número: Si el resultado es el mismo que el número seleccionado, recibirá (98*9) 882<br/><br/>5. Seleccione grande: si el resultado muestra 5,6,7,8,9 obtendrá (98*2) 196<br/><br/>6. Seleccione pequeño: si el resultado muestra 0,1,2,3,4, obtendrá (98 * 2) 196',
    该玩法不允许下注: 'Esta jugabilidad no permite apuestas',
    总赌注: 'Apuesta total',
    赔率: 'Probabilidades',
    选择3个唯一号码: 'Seleccione 3 números únicos',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*Si el número de apertura coincide con los 3 números de apuesta, ganará.',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*Si el número ganador es cualquier combinación de tres números idénticos, ganará.',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*Si el número de apertura coincide con 2 de los números de apuesta, ganará. (Excluyendo tres números idénticos).',
    选择2个相同的数字: 'Seleccione 2 números idénticos',
    选择一对独特的数字: 'Seleccione un par de números únicos',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。':
        'Seleccione al menos 1 par de números idénticos y 1 par de números diferentes para apostar, si el número de apertura coincide con el número de apuesta, ganará.',
    选择2个不同的数字: 'Seleccione 2 números diferentes',
    选择3个不同的数字: 'Seleccione 3 números diferentes',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*Seleccione 3 o más números diferentes. Si los 3 números seleccionados son diferentes y coinciden, ganará',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*Seleccione 2 o más números diferentes. Si los 2 números seleccionados son diferentes y coinciden, ganará.',
    '*若开奖号码为三个连续号码，则中奖。': '*Si el número ganador es una combinación de tres números consecutivos, ganará.',
    玩法提示1: 'Elige 2 números iguales. Si los resultados del sorteo coinciden con tu selección, ganas (a menos que 3 números sean iguales).',
    玩法提示2: 'Elige 2 números iguales y 1 número diferente. Si los resultados del sorteo coinciden con tu selección, ganas.',
    玩法提示3: 'Elige 3 números iguales. Si los resultados del sorteo coinciden con tu selección, ganas.',
    玩法提示4: 'Elige 3 números iguales. Si los resultados del sorteo son tres números iguales, ganas.',
    玩法提示5: 'Elige 3 o más números diferentes. Si los resultados del sorteo coinciden con tu selección, ganas.',
    玩法提示6: 'Elige 3 números consecutivos. Si los resultados del sorteo son tres números consecutivos, ganas.',
    玩法提示7: 'Elige 2 o más números diferentes. Si los resultados del sorteo son números diferentes y coinciden con los números seleccionados, ganas.',
    K3彩票: 'K3 Lotería',
    K3规则详情:
        'Un sorteo rápido de 3 dados para obtener 3 números en cada período, los números de los dados consisten en números naturales del 111 al 666 (no 0), los números de los dados no siempre son consecutivos, puedes adivinar los dados completos o parte de los dados.<br/><br/>valor suma<br/>Adivina la suma de valores numéricos de 3 dados<br/><br/>3 números iguales<br/>Haz una apuesta a 3 números especiales que sean iguales (111, 222, ..., 666).<br/><br/>2 números iguales<br/>Haz una apuesta a 2 números iguales<br/><br/>2 números iguales + 1 número diferente<br/>Realizar una apuesta a 2 números idénticos y 1 número diferente<br/><br/>3 números diferentes<br/>Haz una apuesta a 3 números diferentes<br/><br/>2 números diferentes<br/>Realizar una apuesta a 2 números diferentes<br/><br/>3 números consecutivos<br/>Realizar una apuesta a 3 números consecutivos<br/>(123, 234, 345, 456)<br/><br/>Pequeño (3-11)<br/>Grande (12-18)',
    总和: 'Suma',
    '奇/偶': 'Impar/Par',
    '2个相同': '2 iguales',
    '3个相同': '3 iguales',
    '3个连续': '3 consecutivos',
    不同数字: 'Diferentes números',
    '5D彩票': '5D Lotería',
    '5D规则详情':
        'Dibujar instrucciones<br/>Un número de 5 dígitos (00000-99999) se sorteará aleatoriamente en cada período<br/>por ejemplo:<br/>El número de sorteo para este Periodo es 12345<br/>Un=1<br/>B=2<br/>c=3<br/>D=4<br/>mi=5<br/>SUMA=A+B+C+D+E=15<br/>Como jugar<br/>Los jugadores pueden especificar seis resultados de apuestas A, B, C, D, E y la suma.<br/>A, B, C, D, E se pueden comprar<br/>Número (0 1 2 3 4 5 6 7 8 9)<br/>Bajo (0 1 2 3 4)<br/>Impar (1 3 5 7 9)<br/>Alto (5 6 7 8 9)<br/>Impar (1 3 5 7 9)<br/>Par (0 2 4 6 8)<br/>Suma = A+B+C+D+E se puede comprar<br/>Bajo (0-22)<br/>Alto (23-45)<br/>Impar (1 3 ···43 45)<br/>Pareja (0 2 ···42 44)',
    下拉即可刷新: 'Tira hacia abajo para actualizar',
    释放即可刷新: 'Suelte para actualizar',
    没有更多了: 'no más',
    试玩提示: 'Estás entrando en una experiencia de prueba; los retiros no están disponibles después de obtener una ganancia',
    分享链接: 'compartir enlace',
    应用已更新: 'La aplicación se ha actualizado',
    点击确定重启App生效: 'Haga clic en Aceptar para reiniciar la aplicación',
    热门: 'Popular',
    最近: 'Reciente',
    收藏: 'Favoritos',
    邀请好友帮忙提现: '1. Invitar a amigos para que ayuden con los retiros',
    向随机玩家发送邀请以提供帮助: '2. Enviar invitación a un jugador aleatorio para que ayude',
    通过短信发送消息: 'Enviar mensaje en ',
    短信: 'SMS',
    今天剩余提款额度: 'Monto restante del retiro de hoy',
    VIP每日限额: 'VIP límite diario',
    今天剩余提款次数: 'Número de retiros restantes hoy',
    VIP每日提款次数: 'VIP retiros diarios',
    单笔最小提款: 'Retiro mínimo único',
    单笔最大提款: 'Retiro único máximo',
    USDT地址: 'dirección USDT',
    今天提款次数已用完: 'El número de retiros se ha agotado hoy',
    提现提示: 'Consejos de retiro',
    系统异常: 'Excepción del sistema',
    '你好，我们有一份礼物送给你': 'Hola, tenemos un regalo para ti',
    请输入礼品代码: 'Ingresa el código de regalo',
    奖金金额: 'Monto del bono: {value}',
    关注官方渠道获取代码: 'Sigue el canal oficial para obtener el código',
    '该金额暂无可用的充值通道,请更换充值金额': 'No hay ningún canal de recarga disponible para este monto. Cambie el monto de la recarga.',
    联系客服: 'Póngase en contacto con el servicio de atención al cliente',
    上月: 'El mes pasado',
    礼物: 'CUPON/CUPONES',
    公链查询: 'Consulta de cadena pública',
    区块: 'Bloque',
    区块时间: 'Tiempo de bloque',
    哈希: 'Hash',
    trx详情:
        '¿Qué es un valor hash?<br/><br/>Cualquiera que conozca los conceptos básicos de Bitcoin estará expuesto a un concepto, un valor hash. El encabezado del bloque de Bitcoin tiene un hash del bloque anterior, que se usa para apuntar al bloque anterior.<br/><br/>Hash es la transliteración del hash en inglés, también podemos traducirlo como hash, por lo que el valor hash también se llama valor hash. Un valor hash es un valor calculado con una función hash (o función hash/algoritmo hash). Para comprender los valores hash, uno debe comprender la naturaleza de las funciones hash. Una función hash puede transformar computacionalmente una entrada de longitud arbitraria en una salida de longitud fija.<br/><br/>Cada función hash tiene la propiedad de que si el valor de entrada es el mismo, el valor hash de salida es el mismo. Si los valores de entrada son diferentes, los hashes de salida suelen ser diferentes, pero existe una posibilidad muy pequeña de una colisión de hashes. Si se descarta una colisión de hash con un ligero cambio en el valor de entrada, se genera un valor hash completamente no relacionado. Dado que la función hash es irreversible y fácil de verificar, es casi imposible revertir el valor de entrada a través del valor hash de salida. Si hay un valor de entrada, el valor hash correspondiente se puede verificar de inmediato.<br/><br/>Por lo tanto, el valor hash de cada bloque es único, aleatorio, irrompible, infalsificable, el valor hash del bloque se identifica automáticamente y el registro no se puede manipular.<br/><br/>¿Cuántos tipos de USDT existen?<br/><br/>1. Omni-USDT basado en la red Bitcoin, la dirección de depósito es la dirección BTC, y el depósito y el retiro pasan por la red BTC;<br/><br/>2. ERC20-USDT basado en el protocolo Ethereum ERC20, la dirección de depósito es la dirección ETH, y el depósito y el retiro pasan por la red ETH;<br/><br/>3. TRC20-USDT se basa en el protocolo TRON TRC20 y la red TRX (TRON), la dirección de depósito es la dirección TRON, y el depósito y retiro se realizan a través de la red TRON.<br/><br/>TrxHash es el hash del bloque TRC20-USDT basado en el protocolo TRON TRC20 y la red TRX (TRON). El último número se utiliza como resultado de la lotería para determinar si ha ganado la lotería (haga clic en Altura del bloque para ir a la cadena pública para consultar el hash del bloque único)<br/><br/>Las reglas del juego son las siguientes:<br/><br/>1. 1 sorteo de lotería durante 1 minuto, compre dentro de los 45 segundos y el resultado no se puede comprar dentro de los 15 segundos antes de la apertura.<br/><br/>2. Desbloqueo de compra durante todo el día. El número total de compras en un día es 1440.<br/><br/>3. 3 puntos 1 vez, 5 puntos 1 vez, 10 puntos 1 vez, las reglas son las mismas que 1 punto 1 vez excepto que el tiempo del sorteo es diferente.<br/><br/>4. El último dígito del hash del bloque se usa como resultado de la lotería:<br/><br/>Por ejemplo:<br/><br/>Si el valor hash es **b569, el resultado de la lotería es 9<br/><br/>Valor hash **d14c, el resultado de la lotería es 4<br/><br/>Si gasta 100 para operar, después de deducir la tarifa de servicio del 2%, monto del contrato: 98<br/><br/>l Elija verde: si el resultado muestra 1,3,7,9, obtendrá (98 * 2) = 196; si el resultado muestra 5, obtendrá (98 * 2) = 196<br/><br/>l Elija rojo: si el resultado muestra 2,4,6,8, obtendrá (98 * 2) = 196; si el resultado es 0, obtendrás (98 * 2) = 196<br/><br/>l elige morado: si el resultado es 0 o 5, obtendrás (98 * 2) = 196<br/><br/>l selecciona el número: si el resultado de la apertura es el mismo que el que seleccionaste, obtendrás (98 * 9) = 882<br/><br/>l elige Grande: si el resultado es 5,6,7,8,9 obtendrás (98 * 2) = 196<br/><br/>l selecciona Pequeño: si el resultado es 0,1,2,3,4 obtendrás (98 * 2) = 196',
    'WIN TRX彩票': 'WIN TRX Lotería',
    确认进入游戏吗: '¿Estás seguro de que quieres jugar?',
    奖励兑换码: 'Código de premio',
    注册时间: 'Tiempo de registro',
    '7 天全额存款': 'Depósito total de <span>{value}</span> días',
    何时可以领取奖金: 'Tiempo para recibir el bono',
    神秘奖金: 'Premio misterioso',
    活动已过期: 'Actividad expirada',
    已领取: 'Recibido',
    首次存款: 'Depósito inicial',
    活动说明: 'Descripción de la actividad',
    等级优惠: 'Descuento de nivel',
    当前等级: 'Nivel actual',
    铁: 'Hierro',
    青铜: 'Bronce',
    白银: 'Plata',
    黄金: 'Oro',
    铂金: 'Platino',
    钻石: 'Diamante',
    近7天游戏营业额: 'Ingresos del juego en los últimos {value} días',
    未达成: 'No cumplido',
    已申请: 'Aplicado',
    已收到: 'Recibido',
    保存: 'ahorrar',
    每周奖金: 'bono semanal',
    领取时间: 'Hora de recogida',
    加载更多: 'Cargar más',
    游戏大厅: 'Sala de juegos',
    更多游戏: 'Más juegos',
    底部描述:
        '{value} es operado por {value2}, empresa con número de registro 142922, con domicilio social en Zuikertuintjeweg Z/N (Torre Zuikertuin) Curazao y está autorizado por el Gobierno de Curazao. {value} opera bajo la Licencia Maestra de Proveedor de Servicios de Juegos, N.V. Número de Licencia: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. Este producto está destinado a usuarios mayores de 18 años y está destinado únicamente a fines de entretenimiento.</p><p>2. Este juego contiene compras dentro de la aplicación.</p><p>3. El hecho de que un jugador juegue o gane en un juego de apuestas sociales no significa que gane en apuestas con dinero real y juegos relacionados en el futuro.</p>',
    版权声明: '{value} {value2}. Todos los derechos reservados. 18+',
    支付成功: 'Pago exitoso',
    最大掉落: '{value} a la vez Caída máxima',
    每天几次: '{value} veces al día',
    当前输赢: 'Pérdida de corriente',
    当前可领金额: 'Cantidad actual disponible',
    上一期输赢: 'Pérdida del último número',
    上一期可领金额: 'Cantidad disponible para el período anterior',
    赎回基金表: 'Tabla de fondos de rescate',
    比赛失败: 'El juego falló',
    赎回费用: 'tarifa de reembolso',
    救援金: 'fondo de ayuda',
    本周补偿: 'Compensación para esta semana',
    本周盈利: 'Ganancia esta semana',
    可获得补偿: 'Compensación disponible',
    本周的补偿将分配到: 'La compensación de esta semana se distribuirá a',
    每周报酬: 'Compensación Semanal',
    补偿: 'Compensación',
    累计投注: 'Apuestas acumuladas',
    通过累积投注提升VIP等级: 'Mejora el nivel VIP acumulando apuestas',
    立即下载: 'Descarga ahora',
    下载应用程序: 'Descarga la aplicación',
    您要下载并安装APP吗: '¿Quieres descargar y instalar la aplicación?',
    暂无可用手机号: 'Aún no hay ningún número de teléfono móvil disponible',
    '下载地址不存在，请稍后重试': 'No existe la dirección de descarga, por favor, inténtelo de nuevo más tarde',
    '下载已开始，请在通知栏查看下载进度': 'El descargue ha comenzado, por favor, vea el progreso del descargue en la barra de notificaciones',
    '下载失败，请稍后重试': 'El descargue ha fallado, por favor, inténtelo de nuevo más tarde',
    支付倒计时: 'Por favor, complete el pago en {value}',
    支付方式: 'Método de pago',
    钱包支付: 'Pago de billetera',
    取消充值申请: 'Cancelar solicitud de depósito',
    查看充值记录: 'Ver registro de depósito',
    打开App: 'Abrir {value}',
    每日游戏收入: 'Ingresos del juego por día',
    签到奖金: 'Bono de inicio de sesión',
    手机号首位不能为0: 'El número de teléfono no puede comenzar con 0',
    真实姓名只能包含英文字母和空格: 'El nombre real solo puede contener letras y espacios',
    请输入正确的银行卡账号: 'Por favor, ingrese un número de cuenta de banco válido',
    请输入15位仅包含数字和字母的账号: 'Ingrese un número de cuenta de 15 caracteres con letras o dígitos',
    请输入CLABE账号: 'Por favor, ingrese cuenta CLABE',
    请输入正确的CLABE账号: 'Por favor, ingrese una cuenta CLABE válida',
    利息: 'INTERES',
    转入金额必须大于: 'El valor de transferencia debe ser mayor que {value}',
    最小金额为: 'Mínimo {value}, solo números enteros',
    已转入: 'Cargado',
    年利率: 'Tasa de interés anual {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> Ciclo de resolución (Máx. <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> Pendiente <span style="color: var(--profit-text-warning);"> {value} </span> (Completado {value2}) </span>`,
    收取: 'Recibir',
    累计收益: 'Ingresos acumulados <span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: 'Tipo de transacción',
    奖金: 'Bono',
    详细资料: 'Perfil detallado',
    规则说明: 'Reglas de cuidado',
    解决周期: 'Ciclo de resolución',
    转账金额: 'Monto de transferencia',
    当前时间: 'Hora actual',
    存款利息结算: 'Después de este depósito, el primer interés aparecerá en {value}',
    确认转账: 'Confirmación de transferencia',
    当前储蓄本: 'Libro de ahorros actual',
    转出金额: 'Monto transferido',
    本次循环的倒计时: 'Tiempo de cuenta regresiva para este ciclo',
    提取利息提示: '¡Una vez retirado, perderá el interés de este ciclo!',
    确认提现: 'Confirmar retiro',
    转入: 'Transferir',
    账户余额: 'Saldo de la cuenta',
    提款最小金额: 'Monto mínimo de retiro {value}',
    提取金额必须大于: 'El monto de extracción debe ser mayor que {value}',
    提取金额不能超过账户金额: 'El monto de extracción no puede exceder el saldo de la cuenta',
    提取成功: 'Retiro exitoso',
    提取失败: 'Retiro fallido',
    转入成功: 'Transferencia exitosa',
    转入失败: 'Transferencia fallida',
    无限: 'Sin límite',
    时: '{value} Hora',
    分: '{value} Minuto',
    秒: '{value} Segundo',
    利息宝未开启: 'El interés no está abierto',
    已完成: 'Completado',
    处理中: 'En proceso',
    已取消: 'Cancelado',
    已提交: 'Enviado',
    审核中: 'En revisión',
    出款中: 'En retiro',
    出款失败: 'Retiro fallido',
    已审核: 'Revisado',
    请输入UTR: 'Por favor, ingrese UTR',
    请输入数字和字母: 'Por favor, ingrese números y letras',
    补单成功: 'Orden de reembolso completada',
    补单失败: 'Orden de reembolso fallida',
    补单: 'Orden de reembolso',
    请输入12位数字: 'Por favor, ingrese 12 dígitos',
    最多只能选择9个号码: 'Solo puede seleccionar hasta 9 números',
    请选择支付方式: 'Por favor, seleccione el método de pago',
    用户ID: 'ID de usuario/Número de teléfono',
    总余额: 'Saldo total',
    提现余额: 'Saldo disponible para retiro',
    请输入用户ID: 'Por favor, ingrese ID de usuario/Número de teléfono',
    TelegramChannel: 'Canal de Telegram',
    真实姓名的长度不小于5个字符: 'El nombre real debe tener al menos 5 caracteres',
    下载: 'DESCARGAR',
    强度: 'Fuerza',
    余额不足: 'Saldo insuficiente',
    客服: 'Soporte',
    有效投注总额: "Apuesta válida total",
    盈亏总额: "Ganancia y pérdida total",
    注册账户: 'Registrar cuenta',
    注册完成后可获得奖励: 'Después de completar el registro, puedes <span class="intro-highlight">obtener {value}</span> recompensas',
    
    // Inicio de sesión de terceros
    第三方登录: 'Inicio de Sesión de Terceros',
    登录方式: 'Método de inicio de sesión',
    
    // Relacionado con la carga de la página de callback
    '正在处理登录...': 'Procesando inicio de sesión...',
    '请稍候，即将为您跳转': 'Por favor espere, redirigiendo...',
    赠送中心: 'Centro de regalo',
    截止日期: 'Fecha de finalización',
    返回顶部: 'Volver arriba',
    游戏: 'Juegos',
    搜索游戏: 'Buscar juegos',
    下注成功: 'Apuesta exitosa',
    下注失败: 'Apuesta fallida',
    游戏历史: 'Historial de juegos',
    期数: 'Periodo',
    存款宝箱: 'Tesoro de Depósito',
    归回累存: 'Acumulación de depósitos de retorno',
    统计截至: 'Estadísticas hasta',
    剩余天数: 'Días restantes',
    当前累计: 'Total acumulado actual',
    距: 'Hasta',
    还差: 'Aún falta',
    当前可领取: 'Disponible para reclamar',
    档: 'Nivel',
    累计门槛: 'Meta acumulada',
    赠送金额: 'Importe del bono',
    打码: 'Requisito de apuesta',
    可提前领取: 'Puede reclamarse anticipadamente. Después de reclamarlo, no se podrán alcanzar niveles superiores',
    活动进行中: 'Evento en curso',
    活动到期领取: 'Evento en curso. La recompensa podrá reclamarse cuando finalice el evento',
    第几天: 'Día {value}',
    已于第几天领取: 'Reclamado <strong>{value1}</strong> el día {value}',
    几天: '{value} días',
    回归每日首存: 'Primer depósito diario del usuario que regresa',
    今日时间: 'Hora de hoy',
    今日首笔存款: 'Primer depósito de hoy',
    可用奖金: 'Bono disponible',
    奖金比例: 'Porcentaje del bono',
    立即领取: 'Reclamar ahora',
    去充值: 'Depositar',
    查看活动: 'Ver evento',
    再充值一点更划算: 'Deposita un poco más para obtener una mejor recompensa',
    当前档: 'Nivel actual',
    冲刺档: 'Nivel objetivo',
    冲: 'Añadir',
    直接领取当前奖励: 'Reclamar {value} ahora',
    活动结束: 'Evento finalizado',
    恭喜领取成功: 'Recompensa reclamada con éxito',
    累计奖励已入账户: 'La recompensa acumulada {value} fue acreditada',
    请完成打码流水后提现: 'Completa el requisito de apuesta antes de retirar',
    知道了: 'Entendido',
    去下注: 'Apostar',
    充值后最高赠送: 'Bonificación máxima después del depósito: {value}',
    倍数: 'Multiplicador',
    必须通过此页面充值才能获得多倍奖金: 'Debes depositar a través de esta página para recibir el bono multiplicador',
    已领取宝箱金额: 'Recompensa del cofre recibida',
    已领取翻倍奖励: 'Bono de {value}x recibido',
    充值领取最高: 'Deposita para recibir hasta {multiple}x, recompensa de {value}',
    说明: 'Instrucciones',
    翻倍充值说明: 'Instrucciones de depósito multiplicador',
    参与活动: 'Participar en el evento',
    领取额外奖励: 'Reclamar recompensa adicional',
    开始时间: 'Hora de inicio',
    流水倍数: 'Multiplicador de apuestas',
    打开: 'Abrir',
    继续领取: 'Continuar reclamando',
    翻倍领取: 'Reclamar recompensa multiplicada',
};
